import React, { useContext, useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { withUnvalidatedControlErrors, withControlErrorHandling } from '@bingads-webui-campaign-react/error-handling';
import { ValidatedLegacyAdSchedule } from '@bingads-webui-campaign/ad-schedule';
import {
  entityIs,
} from '@bingads-webui-campaign-react/form-error';
import {
  TextTitle,
  getPanelErrorProps,
  ValidatedPanel,
} from '@bingads-webui-campaign/wizard-jumbo-card';

import { ERROR_ENTITY } from '../../constants';
import { getAdScheduleDetails } from '../../utils/ad-schedule-shared';
import { AdScheduleImg } from '../../media';
import { AdScheduleShimmer, withShimmer } from '../shimmers';

const campaignDayTimeCriterions = entityIs(ERROR_ENTITY.CampaignDayTimeCriterion);

const ServerValidatedLegacyAdScheduleWithShimmer =
  withShimmer(
    withControlErrorHandling(withUnvalidatedControlErrors(
      ValidatedLegacyAdSchedule,
      { filter: campaignDayTimeCriterions }
    )),
    AdScheduleShimmer
  );

export const AdSchedulePanel = (props) => {
  const i18n = useContext(I18nContext);

  const [adScheduleView, setAdScheduleView] = useState(null);
  const setAdScheduleViewCallback = useCallback((view) => { setAdScheduleView(view); }, []);

  const {
    key,
    isLoading,
    expand,
    data = {},
    ...rest
  } = props;

  const { adSchedules } = data;

  return (
    <ValidatedPanel
      key={key}
      title={<TextTitle
        titleKey={_TL_('Ad schedule')}
        topicKey="pop_BA_Targeting_DayTime"
        details={getAdScheduleDetails(i18n, adScheduleView && adScheduleView.current, true)}
        icon={AdScheduleImg}
      />}
      attentionBeaconProps={{ getExtraProps: getPanelErrorProps }}
      actuationProps={{
        expand,
        expandKey: key,
      }}
      {...rest}
    >
      <ServerValidatedLegacyAdScheduleWithShimmer
        showShimmer={isLoading}
        isCreation
        entity={{ data: { ...data } }}
        validationProps={{
            data: adSchedules,
          }}
        setAdScheduleView={setAdScheduleViewCallback}
      />
    </ValidatedPanel>
  );
};

AdSchedulePanel.propTypes = {
  key: PropTypes.string.isRequired,
  isLoading: PropTypes.bool,
  expand: PropTypes.func.isRequired,
  data: PropTypes.shape({}),
};

AdSchedulePanel.defaultProps = {
  isLoading: false,
  data: {},
};
